"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryModal = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importStar(require("react"));
var MediaContext_1 = require("../MediaContext");
var MediaItemList_1 = require("./MediaItemList");
var MediaUpload_1 = require("./MediaUpload");
var ImageEditor_1 = require("./ImageEditor");
var MediaLibraryModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSelect = _a.onSelect, onImageEditUploadStart = _a.onImageEditUploadStart, onImageEditUploadComplete = _a.onImageEditUploadComplete, openInUploadView = _a.openInUploadView;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    (0, react_2.useEffect)(function () {
        function handlePaste(e) {
            var _a;
            if (!((_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.files.length) ||
                mediaContext.view === 'crop' ||
                mediaContext.view === 'markup')
                return;
            mediaContext.uploadMediaItems(Array.from(e.clipboardData.files));
        }
        if (isOpen)
            document.addEventListener('paste', handlePaste);
        return function () { return document.removeEventListener('paste', handlePaste); };
    }, [isOpen, mediaContext]);
    (0, react_2.useEffect)(function () {
        if (isOpen) {
            mediaContext.loadMediaItems();
            mediaContext.loadMediaConstraints();
            if (openInUploadView) {
                mediaContext.setView('upload');
            }
        }
    }, [isOpen]);
    function handleClose() {
        if (mediaContext.view === 'list') {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }
    var modalContent = null;
    switch (mediaContext.view) {
        case 'list':
            modalContent = react_2.default.createElement(MediaItemList_1.MediaItemList, { onClose: handleClose, onSelect: onSelect });
            break;
        case 'upload':
            modalContent = react_2.default.createElement(MediaUpload_1.MediaUpload, { openInUploadView: openInUploadView });
            break;
        case 'crop':
        case 'markup':
            // Do NOT put the ImageEditor inside of the chakra modal.
            //  Doing so break text boxes in the markup editor.
            return (react_2.default.createElement(ImageEditor_1.ImageEditor, { onImageEditUploadStart: onImageEditUploadStart, onImageEditUploadComplete: onImageEditUploadComplete, onCancel: onClose }));
    }
    return (react_2.default.createElement(react_1.Modal, { isOpen: isOpen, onClose: handleClose },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { height: "90vh", maxWidth: "70%", backgroundColor: "gray.50", pb: 0, my: "auto", display: "flex", flexDirection: "column" }, modalContent)));
};
exports.MediaLibraryModal = MediaLibraryModal;
